import React, { useState, useEffect } from 'react';
import {
    Input,
    FormControl,
    FormLabel,
    Text,
    Box,
    Button,
    Heading,
} from '@chakra-ui/react';
import { ColorButton } from "frontend/core/components/ColorButton";

export const ZipCodeScreen = ({ onProceed, zipcodes, onBack }) => {
    const [inputZip, setInputZip] = useState('');
    const [error, setError] = useState('');
    const [isInvalidZip, setIsInvalidZip] = useState(false);

    // Reset the state on component load
    useEffect(() => {
        resetScreen();
    }, []);

    const resetScreen = () => {
        setInputZip('');
        setError('');
        setIsInvalidZip(false);
    };

    const handleZipChange = (e) => {
        setInputZip(e.target.value);
    };

    const validateZipCode = (zip) => {
        const zipCodeRegex = /^\d{5}$/;
        return zipCodeRegex.test(zip);
    };

    const handleSubmit = () => {
        if (!validateZipCode(inputZip)) {
            setError('Please enter a valid 5-digit zip code.');
            return;
        }

        const validZipcodes = zipcodes.split(',').map((zip) => zip.trim());

        if (validZipcodes.includes(inputZip)) {
            setError('');
            setIsInvalidZip(false);
            onProceed();
        } else {
            setIsInvalidZip(true);
        }
    };

    return (
        <Box
            height="100vh"
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            bg="gray.50"
            p={4}
            role="main"
        >
            <Box
                bg="white"
                p={8}
                borderRadius="md"
                boxShadow="md"
                maxWidth="400px"
                width="100%"
                textAlign="center"
            >
                {/* Main heading for screen readers */}
                <Heading as="h1" fontSize="2xl" fontWeight="bold" mb={6}>
                    Check Availability in Your Area
                </Heading>

                {/* Display error message if service is not available */}
                {isInvalidZip ? (
                    <Text color="red.500" mb={4}>
                        Sorry, we do not provide service in your area.
                    </Text>
                ) : (
                    <FormControl mb={4} isInvalid={!!error}>
                        <FormLabel htmlFor="zipCode" fontWeight="bold">
                            Zip Code
                        </FormLabel>
                        <Input
                            type="text"
                            id="zipCode"
                            name="zipCode"
                            aria-describedby="zipCodeHelp"
                            value={inputZip}
                            onChange={handleZipChange}
                            focusBorderColor="blue.500"
                            errorBorderColor="red.500"
                        />
                        {error && (
                            <Text id="zipCodeHelp" color="red.500" mt={2}>
                                {error}
                            </Text>
                        )}
                    </FormControl>
                )}

                <Box mt={6}>
                    {isInvalidZip ? (
                        <>
                            {/* "Back to Plans" button */}
                            <Button variant="ghost" onClick={onBack} width="100%" colorScheme="gray">
                                Back to Plans
                            </Button>
                        </>
                    ) : (
                        <ColorButton colorScheme="blue" onClick={handleSubmit} width="100%">
                            Proceed
                        </ColorButton>
                    )}
                </Box>
            </Box>
        </Box>
    );
};
